class Marquee {
  constructor() {
    this.marqueeWrapper = document.querySelector('.marquee__marquee-wrapper');
    this.animationPaused = false;
    this.originalAnimation = '';
    this.init();
  }

  init() {
    if (!this.marqueeWrapper) return;

    this.originalAnimation = this.marqueeWrapper.style.animation;

    this.marqueeWrapper.addEventListener('mouseenter', this.pauseAnimation.bind(this));
    this.marqueeWrapper.addEventListener('mouseleave', this.resumeAnimation.bind(this));

    this.marqueeWrapper.addEventListener('touchstart', this.pauseAnimation.bind(this));
    this.marqueeWrapper.addEventListener('touchend', this.resumeAnimation.bind(this));
  }

  pauseAnimation() {
    if (this.animationPaused) return;

    this.marqueeWrapper.style.animationPlayState = 'paused';
    this.animationPaused = true;
  }

  resumeAnimation() {
    if (!this.animationPaused) return;

    this.marqueeWrapper.style.animationPlayState = 'running';
    this.animationPaused = false;
  }
}

new Marquee();